import type { ReactNode } from 'react'
import { Navigate } from 'react-router-dom'
import { useAuth } from '../context/AuthContext'
import { PERMISSION_KEYS } from '../config/permissions'
import { loadingClass } from '../lib/ui'

/** Доступ к разделу «Категории»: чтение расходников или продукции. */
export function RequireCategoriesAccess({ children }: { children: ReactNode }) {
  const { can, loading } = useAuth()

  if (loading) {
    return (
      <div className={loadingClass}>
        <p>Загрузка…</p>
      </div>
    )
  }

  if (!can(PERMISSION_KEYS.CONSUMABLES_READ) && !can(PERMISSION_KEYS.PRODUCTS_READ)) {
    return <Navigate to="/admin/administration/panel" replace />
  }

  return <>{children}</>
}
